import { DropdownChevron } from '#/components/Dropdown/Chevron/DropdownChevron';
import { Dropdown } from '#/components/Dropdown/Dropdown';
import { DropdownFoldMenu } from '#/components/Dropdown/menus/Fold/DropdownFoldMenu';
import { useIsClient } from '#/hooks/useIsClient';
import { useViewportBreakpoint } from '#/hooks/viewport/useViewportBreakpoint';
import { LayoutHeaderButton } from '#/layouts/Layout/Header/Button/LayoutHeaderButton';

export function ApiAndIntegrationsDropdown() {
  const isClient = useIsClient();
  const viewport = useViewportBreakpoint();
  const isDesktop = isClient && ['md', 'lg'].includes(viewport);

  return (
    <Dropdown
      trigger={
        <LayoutHeaderButton
          data={
            isDesktop
              ? {
                  type: 'link',
                  href: '/volunteersolutions',
                  anchorType: 'native',
                  trackClicked: {
                    name: 'API & Integrations',
                    properties: { context: 'Header' },
                  },
                }
              : { type: 'inert' }
          }
          variant="grey"
          qaId="page-header-api-and-integrations-dropdown-trigger"
        >
          API & Integrations <DropdownChevron />
        </LayoutHeaderButton>
      }
      desktopTriggersOnHover
    >
      <DropdownFoldMenu
        left={{
          title: 'Business Solutions',
          columnCountOverride: 1,
          items: [
            {
              iconName: 'cogs',
              title: 'API',
              href: '/en/open-network-api',
              qaId: 'nav-api-link',
              trackClicked: {
                name: 'API',
                context: 'Header Dropdown > API & Integrations',
              },
              fullPageReload: true,
            },
            {
              iconName: 'puzzle-piece',
              title: 'Search Module',
              href: '/volunteer-search-widget',
              qaId: 'nav-search-module-link',
              trackClicked: {
                name: 'Search Module',
                context: 'Header Dropdown > API & Integrations',
              },
              fullPageReload: true,
            },
            {
              iconName: 'browser',
              title: 'Volunteer Engagement Pages',
              href: '/en/volunteer-engagement-pages',
              qaId: 'nav-volunteer-engagement-pages-link',
              trackClicked: {
                name: 'Volunteer Engagement Pages',
                context: 'Header Dropdown > API & Integrations',
              },
              fullPageReload: true,
            },

            {
              iconName: 'building',
              title: 'CSR Partners',
              href: '/csr-services',
              qaId: 'nav-csr-partners-link',
              trackClicked: {
                name: 'Partners',
                context: 'Header Dropdown > API & Integrations',
              },
              fullPageReload: true,
            },
          ],
        }}
        right={undefined}
      />
    </Dropdown>
  );
}
